module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.2-101.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.3.2.md
// module id = 518
// module chunks = 309